<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :title="workCenter.pkId ? '编辑' : '新建'"
    width="600px"
    @close="$reset('form')"
  >
    <el-form ref="form" :model="workCenter" :rules="ruleValidate" class="form" label-width="100px">
      <el-form-item v-if="workCenter.pkId" label="生产中心编号">
        <el-input v-model="workCenter.workCenterNo" disabled />
      </el-form-item>
      <el-form-item label="生产中心名称" prop="workCenterName">
        <el-input v-model="workCenter.workCenterName" placeholder="请输入生产中心名称" clearable />
      </el-form-item>
      <el-form-item label="生产类型" prop="productionType">
        <el-select v-model="workCenter.productionType" placeholder="请选择生产类型" clearable>
          <el-option label="单件完工" :value="0"></el-option>
          <el-option label="批量完工" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="载具绑定类型" prop="bindVehicleType">
        <el-select v-model="workCenter.bindVehicleType" placeholder="请选择载具绑定类型" clearable>
          <el-option label="不绑定" :value="0"></el-option>
          <el-option label="需绑定验证" :value="1"></el-option>
          <el-option label="需绑不验证" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="上料验证" prop="isLoadMaterial">
        <el-select v-model="workCenter.isLoadMaterial" placeholder="请选择是否上料验证" clearable>
          <el-option label="不需要" :value="0" />
          <el-option label="需要" :value="1" />
        </el-select>
      </el-form-item>
      <el-form-item label="自动派工" prop="isAutomaticDispatch">
        <el-select v-model="workCenter.isAutomaticDispatch" placeholder="请选择是否自动派工" clearable>
          <el-option label="否" :value="0" />
          <el-option label="是" :value="1" />
        </el-select>
      </el-form-item>
      <el-form-item label="所属车间" prop="workshopName">
        <el-input v-model="workCenter.workshopName" placeholder="请选择所属车间" readonly>
          <el-button slot="append" @click="$refs.selectWorkShop.open()" icon="el-icon-search"></el-button>
        </el-input>
        <work-shop-select ref="selectWorkShop" @select="selectWorkShop" />
      </el-form-item>
      <el-form-item label="线边库" prop="warehouseName">
        <el-input v-model="workCenter.warehouseName" placeholder="请选择线边库">
          <el-button slot="append" @click="$refs.warehouseSelect.open()" icon="el-icon-search"></el-button>
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="submitHandle">确定</el-button>
    </span>
    <warehouse-select ref="warehouseSelect" @select="selectLocation" />
  </el-dialog>
</template>

<script>
import WorkShopSelect from "@/views/information/WorkShop/WorkShopSelect";
import WarehouseSelect from "@/views/information/WarehouseNew/WarehouseSelect";
export default {
  name: "WorkCenterEdit",
  components: { WorkShopSelect, WarehouseSelect },
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      workCenter: {
        workCenterName: "",
        workshopName: "",
        productionType: "",
        bindVehicleType: "",
        isLoadMaterial: "",
        warehouseName: "",
        isAutomaticDispatch: 0,
      },
      ruleValidate: {
        workCenterName: { required: true, message: "请输入生产中心名称", trigger: "blur" },
        productionType: { required: true, message: "请选择生产类型", trigger: "change" },
        bindVehicleType: { required: true, message: "请选择载具绑定类型", trigger: "change" },
        isLoadMaterial: { required: true, message: "请选择是否需要上料验证", trigger: "change" },
        workshopName: { required: true, message: "请选择所属车间", trigger: "change" },
        warehouseName: { required: true, message: "请选择线边库", trigger: "change" },
        isAutomaticDispatch: { required: true, message: "请选择是否自动派工", trigger: "change" },
      },
    };
  },
  methods: {
    open(row) {
      this.dialogVisible = true;
      if (row) {
        this.workCenter = Object.assign(this.workCenter, row);
      }
    },

    // 选择所属车间
    selectWorkShop(row) {
      this.workCenter.workshopId = row.pkid;
      this.workCenter.workshopName = row.workshopName;
    },

    // 选择线边库
    selectLocation(row) {
      this.workCenter.warehouseNo = row.warehouseNo;
      this.workCenter.warehouseName = row.warehouseName;
    },

    // 确定
    submitHandle() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          this.$http
            .save("basic", "workCenters", this.workCenter)
            .then((resp) => {
              this.submitLoading = false;
              if (resp.success) {
                if (this.workCenter.pkId) {
                  this.$emit("save-success");
                  this.$message.success("编辑成功");
                } else {
                  this.$emit("save-success");
                  this.$message.success("添加成功");
                }
                this.dialogVisible = false;
              }
            })
            .catch(() => {
              this.submitLoading = false;
            });
        }
      });
    },
  },
};
</script>
